"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StatusRulesNamesEnum = void 0;
var StatusRulesNamesEnum;
(function (StatusRulesNamesEnum) {
    StatusRulesNamesEnum["ADMIN_VALIDATION"] = "admin-validation";
    StatusRulesNamesEnum["AGREEMENT_OWNER"] = "agreement-owner";
    StatusRulesNamesEnum["AUTO_ASSIGN_PARTNER"] = "auto-assign-partner";
    StatusRulesNamesEnum["AUTO_CREATE_JOB_OK"] = "auto-create-job-ok";
    StatusRulesNamesEnum["BRAND_INFO_GENERIC"] = "brand-info-generic";
    StatusRulesNamesEnum["BRAND_PAUSE_GENERIC"] = "brand-pause-generic";
    StatusRulesNamesEnum["BRAND_PRODUCT_ORDERING"] = "brand-product-ordering";
    StatusRulesNamesEnum["CHARGEPOINT_REQUIRED"] = "chargepoint-required";
    StatusRulesNamesEnum["CUSTOMER_INFO"] = "customer-info";
    StatusRulesNamesEnum["CUSTOMER_INFO_GENERIC"] = "customer-info-generic";
    StatusRulesNamesEnum["CUSTOMER_NOT_REACHABLE"] = "customer-not-reachable";
    StatusRulesNamesEnum["CUSTOMER_PAUSE_GENERIC"] = "customer-pause-generic";
    StatusRulesNamesEnum["CUSTOMER_PREWORK_BEFORE_ACCEPTED"] = "customer-prework-before-accepted";
    StatusRulesNamesEnum["CUSTOMER_PREWORK"] = "customer-prework";
    StatusRulesNamesEnum["CUSTOMER_WAITING_PRODUCT"] = "customer-waiting-product";
    StatusRulesNamesEnum["CUSTOMER_WAITING_SUBSIDY"] = "customer-waiting-subsidy";
    StatusRulesNamesEnum["CUSTOMER_SIGNATURE"] = "customer-signature";
    StatusRulesNamesEnum["JOB_CREATION_TARGET_STATUS"] = "job-creation-target-status";
    StatusRulesNamesEnum["METER_APPLICATION"] = "meter-application";
    StatusRulesNamesEnum["MISSING_EID"] = "missing-eid";
    StatusRulesNamesEnum["MISSING_INVOICING_EID"] = "missing-invoicing-eid";
    StatusRulesNamesEnum["NETWORK_OPERATOR"] = "network-operator";
    StatusRulesNamesEnum["PARTNER_INFO"] = "partner-info";
    StatusRulesNamesEnum["PARTNER_INFO_GENERIC"] = "partner-info-generic";
    StatusRulesNamesEnum["PARTNER_ONBOARDING"] = "partner-onboarding";
    StatusRulesNamesEnum["PARTNER_PAUSE_GENERIC"] = "partner-pause-generic";
    StatusRulesNamesEnum["PARTNER_QUOTE_VALIDATION"] = "partner-quote-validation";
    StatusRulesNamesEnum["PRODUCT_ORDERING"] = "product-ordering";
    StatusRulesNamesEnum["HOME_ELECTRICIAN_NOT_REACHABLE"] = "home-electrician-not-reachable";
    StatusRulesNamesEnum["SERIAL_NUMBER_REQUIRED"] = "serial-number-required";
})(StatusRulesNamesEnum = exports.StatusRulesNamesEnum || (exports.StatusRulesNamesEnum = {}));
//# sourceMappingURL=status-rules-names-enum.js.map